import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('employee/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('employee/list', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('employee/all', val_params);
  }

  get(val_id: number) {
    return this.restService.get('employee/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('employee/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('employee/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('employee/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('employee/delete', val_id);
  }


  
}
